module.exports = __webpack_public_path__ + "images/6e8da46a.www_2_group_cht.png";


//////////////////
// WEBPACK FOOTER
// ./images/groupintro/www_2_group_cht.png
// module id = 625
// module chunks = 0